module.exports = __webpack_public_path__ + "images/1b8b50a1efd3a77a8c711a34f29015be.svg";